module.exports = __webpack_public_path__ + "static/media/CenturyGothicBold.0c5fb111.svg";